import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Loader2, ArrowLeft, Mail } from 'lucide-react';
import { BrandLogo } from '../components/brand/BrandLogo';

const API = process.env.REACT_APP_BACKEND_URL;

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const res = await fetch(`${API}/api/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || 'An error occurred');
      setSent(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Link to="/" className="inline-flex items-center gap-2">
            <BrandLogo size="lg" />
          </Link>
        </div>

        <div className="bg-white rounded-xl border border-slate-200 p-8 shadow-sm">
          {sent ? (
            <div className="text-center" data-testid="forgot-password-success">
              <div className="w-14 h-14 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Mail className="w-7 h-7 text-[#0B0D12]" />
              </div>
              <h1 className="text-2xl font-bold text-slate-900 mb-2">Vérifiez vos emails</h1>
              <p className="text-slate-600 mb-6">
                Si un compte existe pour <strong>{email}</strong>, vous recevrez un lien de réinitialisation sous peu.
              </p>
              <Link to="/login">
                <Button variant="outline" className="w-full" data-testid="back-to-login-btn">
                  <ArrowLeft className="w-4 h-4 mr-2" />
                  Retour à la connexion
                </Button>
              </Link>
            </div>
          ) : (
            <>
              <h1 className="text-2xl font-bold text-slate-900 mb-2">Mot de passe oublié ?</h1>
              <p className="text-slate-600 mb-6">Entrez votre email et nous vous enverrons un lien de réinitialisation.</p>

              {error && (
                <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-6" data-testid="forgot-password-error">
                  {error}
                </div>
              )}

              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="space-y-2">
                  <Label htmlFor="email">Email</Label>
                  <Input
                    id="email"
                    type="email"
                    placeholder="you@example.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    data-testid="forgot-password-email-input"
                  />
                </div>
                <Button
                  type="submit"
                  className="w-full bg-[#0B0D12] hover:bg-black"
                  disabled={loading}
                  data-testid="forgot-password-submit-btn"
                >
                  {loading ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : null}
                  Envoyer le lien
                </Button>
              </form>

              <p className="mt-6 text-center text-sm text-slate-600">
                <Link to="/login" className="text-[#0B0D12] underline underline-offset-4 hover:text-black font-medium inline-flex items-center gap-1">
                  <ArrowLeft className="w-3 h-3" />
                  Retour à la connexion
                </Link>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
